<template>
    <el-dialog
        :title="formDialog.title"
        :visible.sync="formDialog.visible"
        direction="rtl"
        :before-close="closeDialog"
        width="30%"
        append-to-body
    >
        <div class="dialog-form">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="120px"
                label-position="left"
            >
                <el-form-item label="厅名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="上/下线" prop="is_valid">
                    <el-select v-model="ruleForm.is_valid" clearable placeholder="上/下线">
                        <el-option label="上线" value="1"></el-option>
                        <el-option label="下线" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveDialog('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
let formFields = {
    store_id: '',
    title: '',
    is_valid: '1',
    sort: 0,
};

export default {
    props: {
        parent: {}
    },
    data() {
        let region = dictionary.getRegion();

        return {
            formDialog: {
                title: '',
                visible: false,
                method: 'create'
            },
            region: region,
            ruleForm: Object.assign({}, formFields),
            rules: {
                title: [{ required: true, message: '请输入账号名称', trigger: 'blur' }]
            }
        };
    },
    methods: {
        // 显示添加、编辑渠道视图
        showDialog(row, type = 'create') {
            // let that = this;
            this.ruleForm = Object.assign({}, formFields);
            this.ruleForm.store_id = row.store_id;
            this.formDialog.visible = true;
            // 添加账号
            if (type == 'create') {
                this.formDialog.title = '添加厅信息';
                this.formDialog.action = '/api/dictionary.hall/save';
                this.ruleForm.hotel_id = row.hotel_id;
                return false;
            }

            // 编辑渠道
            this.formDialog.title = '编辑厅信息';
            this.formDialog.action = '/api/dictionary.hall/save';
            row.is_valid =  row.is_valid + '';
            this.ruleForm = Object.assign({}, row);
        },

        // 保存
        saveDialog(formName) {
            let that = this;
            let query = this.ruleForm;
            let dialog = this.formDialog;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$post(dialog.action, query).then(function(response) {
                        if (response.code == '200') {
                            that.parent.getTableData();
                            that.closeDialog();
                            that.$message.success(response.msg);
                        } else {
                            that.$message.error(response.msg);
                        }
                    });
                } else {
                    this.$message('请填写完整并检查您的填写信息');
                }
            });
        },
        // 清空内容
        closeDialog() {
            // 重新初始化数据
            this.formDialog.visible = false;
            this.$refs['ruleForm'].resetFields();
             this.ruleForm = Object.assign({}, formFields);
        }
    }
};
</script>

<style lang="less">
.dialog-form {
    padding: 20px;
}

/* input Number类型不要上下箭头 */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}
</style>
